// extracted by mini-css-extract-plugin
export default {"genericCard":"xm-z","inline":"ym-z","mastercard":"zm-z","discover":"Am-z","visa":"Bm-z","amex":"Cm-z","active":"Dm-z"};